import { useCallback, useState } from 'react';
import {getNbaSeason, getNcaafbSeason, getNflSeason} from '../../../utils/timeUtils';

const removeNonLetters = (condition: string) => {
    return condition.replace(/[^a-zA-Z]/g, '');
};

export const useSdqlQuery = (sport: string = 'nba') => {
    let seasonToUse = getNbaSeason()
    if(sport === 'nfl') seasonToUse = getNflSeason()
    if(sport === 'ncaafb') seasonToUse = getNcaafbSeason()
    const defaultQueryString = `season>=${seasonToUse}`;
    const [queryString, setQueryString] = useState<string>(defaultQueryString);

    const handleSdqlStringChange = useCallback((sdqlCondition: string, reset: boolean = false) => {
        if(reset) {
            setQueryString(defaultQueryString);
            return;
        }
        const existingConditions = queryString.split(' and ').filter((condition: string) => {
            return condition.trim() !== '';
        });

        const newConditionParam = removeNonLetters(sdqlCondition.split('=')[0]);
        const conditionExists = existingConditions.some((condition) => condition === sdqlCondition);

        if (conditionExists) {
            const updatedConditions = existingConditions.filter((condition) => condition !== sdqlCondition);
            setQueryString(updatedConditions.join(' and '));
        } else {
            const existingConditionForParam = existingConditions.find((condition) => {
                const existingConditionParam = removeNonLetters(condition.split('=')[0]);
                return newConditionParam === existingConditionParam;
            });

            if (existingConditionForParam) {
                const existingConditionIndex = existingConditions.indexOf(existingConditionForParam);
                existingConditions.splice(existingConditionIndex, 1, sdqlCondition);
            } else {
                existingConditions.push(sdqlCondition);
            }

            setQueryString(existingConditions.join(' and '));
        }
    }, [queryString]);

    return { handleSdqlStringChange, queryString };
};
